module.exports = __webpack_public_path__ + "static/img/6.f262d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/6.png
// module id = jRCu
// module chunks = 12